import React, { useState } from 'react'
import axiosInstance from '../../hooks/axiosInstance'
import { toast } from 'react-toastify'

function EditMemberInfo({member, close, refreshPage}) {
    const [loading, setLoading] =  useState(false)
    const [formData, setFormData] =  useState({
        membershipId: member?.membership_id,
    })

    const handleChange = (e) => {
        const {name, value} = e.target

        setFormData(prevFormData => (
            {...prevFormData, [name]: value}
        ))
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if(!formData.membershipId){
            toast.error("Membership ID cannot be empty")
            return
        }

        setLoading(true)
        axiosInstance.patch(`/association/associations/members/${member.id}`, formData)
            .then(res => {
                toast.success(res.data.message)
                refreshPage()
                close()
            })
            .catch(err => {
                console.log(err.response);
                toast.error("An error occured. Please, try again")
            })
            .finally(() => setLoading(false))

    }
    
  return (
    <div>
        <form onSubmit={handleSubmit}>
            <div className="mb-3">
                <label for="className=" className="form-label">Membership ID</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Membership ID"
                    name='membershipId'
                    value={formData.membershipId}
                    onChange={handleChange}
                    required
                />
                {/* {validationError.email && (<small className="text-danger mt-1 mb-0">{validationError.email[0]}</small>)} */}
            </div>
            <div className="text-center mt-4">
                <button className="btn btn-success w-100" type="submit" disabled={loading}>
                    {loading ? <div className="spinner-border spinner-border-sm text-light"></div> : 'Update'}
                </button>
            </div>
        </form>
    </div>
  )
}

export default EditMemberInfo
